import dateFormat from "dateformat";
import moment from "moment";

export const formatDate = (value, withTime = true, isJSONObject = false) => {
  if (value == null || value === "") return "";
  let raw = isJSONObject ? safeJsonParse(value) : value;

  // Numeric epoch (seconds or milliseconds)
  if (typeof raw === "number" || (typeof raw === "string" && /^\d+$/.test(raw.trim()))) {
    const num = Number(raw);
    if (Number.isFinite(num)) {
      const ms = num > 1e11 ? num : num * 1000; // treat big numbers as ms
      const date = new Date(ms);
      if (!isNaN(date.getTime())) {
        return dateFormat(date, withTime ? "dS mmm yyyy, h:MM TT" : "dS mmm yyyy");
      }
    }
  }

  // Format unix epoch seconds (strict)
  if (moment(raw, "X", true).isValid()) {
    const date = new Date(Number(raw) * 1000);
    return dateFormat(date, withTime ? "dS mmm yyyy, h:MM TT" : "dS mmm yyyy");
  }

  // Format strings like "18-Oct-2025"
  const momentObj = moment(raw, ["DD-MMM-YYYY", "D-MMM-YYYY", "DD-MMM-YY"], true);
  if (momentObj.isValid()) {
    const date = momentObj.toDate();
    // return dateFormat(date, withTime ? "dS mmm yyyy, h:MM TT" : "dS mmm yyyy");
    return dateFormat(date, "dS mmm yyyy"); // omit time for date-only inputs
  }

  const str = String(raw);
  const iso = str.endsWith("Z") ? str : str + "Z";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  return dateFormat(d, withTime ? "dS mmm yyyy, h:MM TT" : "dS mmm yyyy");
};

const safeJsonParse = (s) => {
  try { return JSON.parse(s); } catch { return s; }
};

export default formatDate;